module.exports = __webpack_public_path__ + "pic/37.acac9138.png";